<div class="relative inline-block w-full">
  <div class="relative">
    <button (click)="toggleDropdown()" class="w-full bg-slate-50 border border-gray-300 text-gray-600 text-sm rounded-lg h-10 px-3 flex items-center justify-between">

      <div *ngIf="selectedOption" class="square-{{selectedOption.indice}}">
      </div>

      <div *ngIf="!selectedOption || selectedOption.value == 'X'" class="square-1 mr-2">
      </div>
      <span><b>{{ selectedOption?.label || placeholder }}</b></span>
      <i class="fas fa-caret-down"></i>
    </button>
  </div>
  <ul *ngIf="dropdownOpen" class="absolute z-50 w-full bg-white border border-gray-300 rounded-lg mt-1 max-h-60 overflow-auto" [style.width]="'20rem'">
    <li (click)="selectOption({icon: null, label: placeholder, value: 'X' })" class="w-full px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center">
      <div class="square-1 mr-2"></div> <b>{{ placeholder }}</b> 
    </li>
    <li *ngFor="let option of options" (click)="selectOption(option)" class="w-full px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center">
      <div class="square-{{option.indice}} mr-2"></div> {{ option.label }}
    </li>
  </ul>
</div>